import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import moment from 'moment';
import popupHOC from '../../../common/popupHOC';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { timeFormatUi } from '../../../../constants/date';
import { maxWorkingMinutesValue, minJobHoursValue, workerBreakMinutesValues } from '../../../../constants/jobs';
import { alertMessages, errorMaxJobHoursMessage, errorMinWorkerHoursMessage } from '../../../../constants/text';
import { calculateActualHours } from '../../../../helpers/jobs';
import { isJobTimelineValid } from '../../../../helpers/date';
import UsersService from '../../../../services/UsersService';

import 'rc-time-picker/assets/index.css';
import GoogleMapReact from 'google-map-react';

class MapsPopup extends Component {
  static propTypes = {
    workerStartLocation: PropTypes.object,
    workerEndLocation: PropTypes.object,
    actual_hours: PropTypes.number,
    workerStartTime: PropTypes.object,
    workerEndTime: PropTypes.object,
    closeMenu: PropTypes.func.isRequired,
    openMenu: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired
  };
  // static defaultProps = {
  //   center: { lat: this.workerStartLocation.lat, lng: this.workerStartLocation.lng },
  //   zoom: 15
  // };

  constructor (props) {
    super(props);

    this.state = {
      startTime: props.workerStartTime || props.jobStartDate,
      endTime: props.workerEndTime || props.jobEndDate,
      selectedBreakOption: props.workerBreakOptions,
      minJobHoursMessage: false,
      maxJobHoursMessage: false
    };
  }

  static defaultProps = {
    center: { lat: 40.73, lng: -73.93 },
    zoom: 12
  };

  getCenter = (coords) => {
    var filteredtextCoordinatesArray = coords.split('|');

    let centerLatArray = [];
    let centerLngArray = [];
    let i = 0;
    for (i = 0; i < filteredtextCoordinatesArray.length; i++) {

      var centerCoords = filteredtextCoordinatesArray[i];
      var centerCoordsArray = centerCoords.split(',');

      if (isNaN(Number(centerCoordsArray[0]))) {
      } else {
        centerLatArray.push(Number(centerCoordsArray[0]));
      }

      if (isNaN(Number(centerCoordsArray[1]))) {
      } else {
        centerLngArray.push(Number(centerCoordsArray[1]));
      }

    }
    let centerLatSum = centerLatArray.reduce(function (a, b) {
      return a + b;
    });
    let centerLngSum = centerLngArray.reduce(function (a, b) {
      return a + b;
    });

    let centerLat = centerLatSum / filteredtextCoordinatesArray.length;
    let centerLng = centerLngSum / filteredtextCoordinatesArray.length;

    console.log(centerLat);
    console.log(centerLng);

    return [ centerLng, centerLat ];
  };

  render () {
    const { isOpen, openMenu, closeMenu, actual_hours, workerStartLocation, workerEndLocation } = this.props;

    const locationStyle = {
      // backgroundColor: '#fdfdfd',
      // color: '#337355',
      height: '4.5em',
      position: 'relative',
      align: 'center',
      width: '4.5em'
    };

    const locationText = {
      textAlign: 'center',
      fontSize: '15px',
      color: '#a53030',
      height: '50%',
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: '50%'
    };

    const MyMarker = ({ text, tooltip }) => (
      // <div style={locationStyle}>
      //   <span style={locationText} title={tooltip}>
      <div className='circleIn'>
        <span className='circleText' title={tooltip}>
          {/*<FontAwesomeIcon icon={faMapMarkerAlt} />*/}
          {text}
        </span>
      </div>
    );


    const points = [];
    let coords = '';
    if (workerStartLocation) {
      points.push({ id: 1, title: 'In', lat: workerStartLocation.lat, lng: workerStartLocation.lng });
      coords = coords + workerStartLocation.lat + ',' + workerStartLocation.lng;
    };

    if (workerEndLocation) {
      points.push({ id: 2, title: 'Out', lat: workerEndLocation.lat, lng: workerEndLocation.lng });
      coords = coords + '|' + workerEndLocation.lat + ',' + workerEndLocation.lng;
    }
    ;

    const [centerLng, centerLat] = this.getCenter(coords);

    const centerMap = {
      center: { lat: centerLat, lng: centerLng }
//      center: { lat: 39.37, lng: -76.77 }
    };

    return (
      <div className='maps-popup position-relative'>
        <button
          className='button button-small button-primary'
          onClick={openMenu}
        >Map
        </button>
        {isOpen && (
          <div className='popupMenu'>
            <header className='d-flex justify-content-between px-3 py-2'>
              <p>Check In / Check Out Locations</p>
              <button
                type='button'
                className='non-button close-popup-icon'
                onClick={closeMenu}
              >
                <FontAwesomeIcon icon={faTimes}/>
              </button>
            </header>

            <GoogleMapReact
              bootstrapURLKeys={{
                key: 'AIzaSyABp93ZCsRNFKtO93ISuDfya_gk90kYvLA',
                language: 'en',
                region: 'US'
              }}
              //  defaultCenter={this.props.center}
              // center={this.state.center}
              defaultCenter={centerMap.center}
              onChildMouseEnter={this.onChildMouseEnter}
              onChildMouseLeave={this.onChildMouseLeave}
              defaultZoom={this.props.zoom}

            >
              {points.map(({ lat, lng, id, title }) => {
                return (
                  <MyMarker
                    key={id}
                    lat={lat}
                    lng={lng}
                    text={title}
                    tooltip={title}
                  />
                );
              })}

            </GoogleMapReact>
          </div>
        )}
      </div>
    );
  }
}

export default popupHOC(MapsPopup);



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/WorkersTab/MapsPopup.js